import React, { useState } from "react";
import axios from "axios";
import "../forms-styles/FormStyles.css";

const RuleBreakReport = () => {
  const [server, setServer] = useState("");
  const [reporter, setReporter] = useState("");
  const [reportedUser, setReportedUser] = useState("");
  const [details, setDetails] = useState("");
  const [proofLink, setProofLink] = useState("");
  const [status, setStatus] = useState("");

  const serverList = ["LIFESTEAL", "SURVIVAL", "BEDWARS", "PRACTICE PVP"];
  const webhookURL =
    "https://discord.com/api/webhooks/1375085903088713861/RnIYIRD5beZ_khjy63Q2p2qiSeND32yX9yQrzLWMCmN-D0krSx8lVP6NnmjiYY6mf2EG";

  // Simple URL validation function
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!server || !reporter || !reportedUser || !proofLink) {
      return alert("Please fill out all required fields including a valid proof link.");
    }

    if (!isValidUrl(proofLink)) {
      return alert("Please enter a valid URL for the proof link.");
    }

    setStatus("Submitting...");

    const payload = {
      content: `New Rule Break Report Submitted:`,
      embeds: [
        {
          title: "Rule Break Report",
          color: 16098851,
          fields: [
            { name: "Reporter Username", value: reporter },
            { name: "Reported Player", value: reportedUser },
            { name: "Server", value: server },
            { name: "Details", value: details || "No details provided." },
            { name: "Proof Link", value: proofLink },
          ],
        },
      ],
    };

    try {
      await axios.post(webhookURL, payload);
      setStatus("✅ Report submitted successfully.");
      setReporter("");
      setReportedUser("");
      setServer("");
      setDetails("");
      setProofLink("");
    } catch (error) {
      console.error(error);
      setStatus("❌ Failed to submit. Please try again.");
    }
  };

  return (
    <div className="form-container">
      <h2>🚨 Rule Break Report</h2>
      <p className="form-note">
        <strong>NOTE:</strong> On <b>LIFESTEAL</b>, everything is allowed except <b>hacks, x-ray, or unfair mods</b>. Only report those violations.
      </p>
      <p className="form-note" style={{ fontWeight: "bold", color: "#d9534f" }}>
        Please upload your images or videos as proof on Google Drive, YouTube, or any other hosting service, then paste the shareable link below.
      </p>
      <form onSubmit={handleSubmit} className="form">
        <label>
          Reporter Username <span className="required">*</span>
          <input
            type="text"
            value={reporter}
            onChange={(e) => setReporter(e.target.value)}
            required
          />
        </label>

        <label>
          Reported Player <span className="required">*</span>
          <input
            type="text"
            value={reportedUser}
            onChange={(e) => setReportedUser(e.target.value)}
            required
          />
        </label>

        <label>
          Server <span className="required">*</span>
          <select
            value={server}
            onChange={(e) => setServer(e.target.value)}
            required
          >
            <option value="">Select a server</option>
            {serverList.map((srv) => (
              <option key={srv} value={srv}>
                {srv}
              </option>
            ))}
          </select>
        </label>

        <label>
          Description (optional)
          <textarea
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            rows="4"
            placeholder="Explain what happened..."
          />
        </label>

        <label>
          Proof Link (required)
          <input
            type="url"
            value={proofLink}
            onChange={(e) => setProofLink(e.target.value)}
            placeholder="https://..."
            required
          />
        </label>

        <button type="submit" className="submit-button">
          📤 Submit Report
        </button>
        <p className="form-status">{status}</p>
      </form>
    </div>
  );
};

export default RuleBreakReport;
